var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"breadcrumb"},[_c('router-link',{attrs:{"to":"/home"}},[_vm._v("上海盛目实业集团有限公司")]),_c('span',[_vm._v(">")]),_c('router-link',{attrs:{"to":"/desc"}},[_vm._v("公司简介")])],1),_c('div',{staticClass:"content-h",domProps:{"innerHTML":_vm._s(_vm.config.companyProfile)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }